import React from 'react';
import { Button, Card, Col, Row, Typography } from 'antd';

import { useGetCompanyInfoQuery } from '../../../store/api/settingsApi';
import { showMessages, messageType } from '../../../helpers/message';
import { BaseError } from '../../../types/apiTypes';

import './ContactUs.less';

const { Text } = Typography;

const ContactUs = () => {
    const { data: companyInfo, error, isLoading } = useGetCompanyInfoQuery();

    React.useEffect(() => {
        if (error) {
            const errorMessage = (error as BaseError)?.data?.message || (error as BaseError)?.error?.data?.message;
            showMessages(errorMessage, messageType.error);
        }
    }, [error]);

    const onClickEmail: React.MouseEventHandler<HTMLElement> = (e) => {
        e.preventDefault();

        const mailTo = encodeURIComponent(companyInfo?.email || '');
        window.location.href = `mailto:${mailTo}`;
    };

    const onClickPhone: React.MouseEventHandler<HTMLElement> = (e) => {
        e.preventDefault();

        const phone = companyInfo?.phone?.replace(/-/, '') || '';
        window.location.href = `tel:${phone}`;
    };

    return (
        <Card title="Contact Us" bordered={true} loading={isLoading}>
            <Row>
                <Col xs={24} md={5}>
                    <Text strong>Email:</Text>
                </Col>
                <Col xs={24} md={10}>
                    <Button type="link" onClick={onClickEmail} className="contact-link">
                        {companyInfo?.email}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={24} md={5}>
                    <Text strong>Phone:</Text>
                </Col>
                <Col xs={24} md={10}>
                    <Button type="link" onClick={onClickPhone} className="contact-link">
                        {companyInfo?.phone}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={24} md={5}>
                    <Text strong>Address:</Text>
                </Col>
                <Col xs={24} md={10}>
                    {companyInfo?.address}
                </Col>
            </Row>
        </Card>
    );
};

export default ContactUs;
